import type { GroupMemberRole } from '@group/domain';
import type { UserPublicProfile } from '@user/PublicProfile';
import type { WorkspaceMemberRole } from '@workspace/domain/workspace';

export type GroupMembers = [UserPublicProfile, GroupMemberRole][];
export type WorkspaceMembers = [UserPublicProfile, WorkspaceMemberRole][];
export type ViewModelIndividualPermissionRole = 'editor' | 'viewer';
export type ViewModelIndividualPermissions = [UserPublicProfile, ViewModelIndividualPermissionRole][];

export const ViewModelIndividualPermissionLocales: Record<ViewModelIndividualPermissionRole, string> = {
  editor: '編集者',
  viewer: '閲覧者',
};
